import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import TimesheetSkeletonLoader from "../components/TimesheetSkeletonLoader";

import { Postrequestcall } from "../../../../request/Postrequest";
import { FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW } from "../../../../constant/Apipath";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";

const ClientTimesheetActivitiesModal = ({
  isOpen,
  onClose,
  setSelectedActivityList,
  jobId,
  actList,
  fromJob,
  setOpenjob,
  openEmployee,
  setOpenemployee,
  setSelectEmployees,
  jobActivities
}) => {
  const [clientJobsActivities, setClientJobsActivities] = useState([]);
  const [fetchedJobActivities, setFetchedJobActivities] = useState([]);
  const [searchActivity, setSearchActivity] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;

  const {
    TEXT_SELECt_JOB_ACTIVITIES,
    BUTTON_NEXT,
    TEXT_SEARCH_JOB_ACTIVITY,
    TEXT_NO_JOB_ACTIVITES_FOUND
  } = ClientEnglishFallback?.SelectJobActivitiesModal(
    multiLanguageData?.SelectJobActivitiesModal || {}
  );

  const [selectedData, setSelecteddata] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setSelecteddata(actList || []);
      setIsInitialized(true);
      if ((!jobActivities || jobActivities.length === 0) && jobId) {
        fetchActivitiesForJob();
      }
    } else {
      setIsInitialized(false);
    }
  }, [isOpen, jobId]);

  const fetchActivitiesForJob = async () => {
    setIsLoading(true);
    try {
      const payload = {
        PageNumber: 1,
        NrRowsPerPage: 100,
        UserLatitude: 0,
        UserLongitude: 0,
        ClientId: selectedClientData?.ClientId,
        SortBy: 2,
        ClientEmployeeId: selectedClientData?.ClientEmployeeId
      };
      const response = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW, payload, TOKEN);
      if (response.status === 200) {
        const jobsData = response?.data?.data || [];
        const matchedJob = jobsData.find((j) => Number(j.clientJobId) === Number(jobId));
        setFetchedJobActivities(matchedJob?.clientJobActivitiesList || []);
      }
    } catch (err) {
      console.error("fetchActivitiesForJob Error: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let rawActivities = (jobActivities && jobActivities.length > 0) ? jobActivities : fetchedJobActivities;
    let data = rawActivities || [];
    
    if (searchActivity) {
      const searchLower = searchActivity.toLowerCase();
      data = data.filter(
        (item) =>
          item?.labourActivityName?.toLowerCase().includes(searchLower) ||
          item?.labourActivityCode?.toLowerCase().includes(searchLower) ||
          item?.activityName?.toLowerCase().includes(searchLower) ||
          item?.activityCode?.toLowerCase().includes(searchLower)
      );
    }
    
    const activeSelected = isInitialized ? selectedData : (actList || []);
    const selectedIds = new Set(
      (activeSelected || []).map((item) => Number(item?.id || item?.activityId || item?.clientActivityId || item?.clientJobActivityId))
    );
    
    const processedData = data.map((activity) => {
      const actId = Number(activity?.id || activity?.clientActivityId || activity?.activityId);
      return {
        ...activity,
        id: actId,
        labourActivityCode: activity?.labourActivityCode || activity?.activityCode || "",
        labourActivityName: activity?.labourActivityName || activity?.activityName || "",
        checked: selectedIds.has(actId)
      };
    });
    
    setClientJobsActivities(processedData);
    if (jobActivities && jobActivities.length > 0) {
      setIsLoading(false);
    }
  }, [searchActivity, actList, selectedData, jobActivities, fetchedJobActivities]);

  const filteredActivities = clientJobsActivities;

  const handleSearchChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setSearchActivity(inputValue);
  };

  const toggleActivitySelection = (activityId) => {
    const targetActId = Number(activityId);
    let toggledAct = null;

    setClientJobsActivities((prev) =>
      prev.map((activity) => {
        const actId = Number(activity?.id || activity?.clientActivityId || activity?.activityId);
        if (actId === targetActId) {
          toggledAct = { ...activity, checked: !activity.checked };
          return toggledAct;
        }
        return activity;
      })
    );

    setSelecteddata((prevSelected) => {
      const exists = prevSelected.some((item) => {
        const itemId = Number(item?.id || item?.activityId || item?.clientActivityId || item?.clientJobActivityId);
        return itemId === targetActId;
      });

      if (exists) {
        return prevSelected.filter((item) => {
          const itemId = Number(item?.id || item?.activityId || item?.clientActivityId || item?.clientJobActivityId);
          return itemId !== targetActId;
        });
      } else if (toggledAct) {
        const actId = toggledAct.id || toggledAct.clientActivityId || toggledAct.activityId;
        return [
          ...prevSelected,
          {
            ...toggledAct,
            id: actId,
            activityId: actId,
            clientActivityId: actId,
            labourActivityCode: toggledAct.labourActivityCode || toggledAct.activityCode || "",
            labourActivityName: toggledAct.labourActivityName || toggledAct.activityName || ""
          }
        ];
      }
      return prevSelected;
    });
  };

  const handleAddJobs = () => {
    const formattedSelected = selectedData.map((activity) => {
      const actId = activity.id || activity.clientActivityId || activity.activityId;
      return {
        ...activity,
        id: actId,
        activityId: actId,
        clientActivityId: actId,
        labourActivityCode: activity.labourActivityCode || activity.activityCode || "",
        labourActivityName: activity.labourActivityName || activity.activityName || ""
      };
    });

    setSelectedActivityList(formattedSelected);
    if (openEmployee) {
      setSelectEmployees(true);
      setOpenemployee(false);
    }
    onClose();
    setSearchActivity("");
    setClientJobsActivities([]);
  };

  const handleModalClose = () => {
    onClose();
    if (fromJob === true) {
      setOpenjob(true);
    }
    setSearchActivity("");
    setClientJobsActivities([]);
  };

  const hasSelectedActivities = selectedData.length > 0;

  return (
    <Modal open={isOpen} onClose={() => handleModalClose()}>
      <Box className="client-modal-responsive" sx={{ minHeight: "500px" }}>
        <Stack direction={"row"} sx={{ padding: "5px 0px", justifyContent: "space-between", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={() => {
              handleModalClose();
            }}>
            <ArrowBackIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              handleModalClose();
            }}
            style={{ padding: "4px" }}>
            <CloseIcon />
          </IconButton>
        </Stack>
        {isLoading ? (
          <Box sx={{ width: "100%" }}>
            <TimesheetSkeletonLoader variant="modal" />
          </Box>
        ) : (
          <>
            <Stack>
              <Typography variant="h6">{TEXT_SELECt_JOB_ACTIVITIES}</Typography>
            </Stack>
            <TextField
              placeholder={TEXT_SEARCH_JOB_ACTIVITY}
              size="small"
              value={searchActivity}
              sx={{
                backgroundColor: "#e4e4e4",
                borderRadius: "10px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none"
                },
                marginTop: "10px"
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }
              }}
              fullWidth
              variant="outlined"
              onChange={(e) => handleSearchChange(e)}
            />
            <List sx={{ overflowY: "auto", minHeight: "320px", maxHeight: "400px", scrollbarWidth: "none" }}>
              {filteredActivities.map((activity) => (
                <ListItem
                  key={activity?.id || activity?.clientActivityId}
                  className="pagelist-content"
                  onClick={() => toggleActivitySelection(activity?.id || activity?.clientActivityId)}
                  sx={{
                    cursor: "pointer",
                    border: "1px solid rgb(216 216 216)",
                    margin: "10px 0px",
                    borderRadius: "10px",
                    padding: "3px 0px"
                  }}>
                  <Checkbox
                    sx={{
                      "&.Mui-checked": {
                        color: CLIENT_ACCENT_COLOR
                      }
                    }}
                    checked={activity.checked}
                  />
                  <ListItemText
                    primary={`${activity.labourActivityCode || activity.activityCode} ${activity.labourActivityName || activity.activityName}`}
                  />
                </ListItem>
              ))}
              {filteredActivities?.length === 0 && (
                <Stack sx={{ textAlign: "center", justifyContent: "center", minHeight: "350px" }}>
                  <Typography variant="h5" style={{ fontSize: "18px" }}>
                    {TEXT_NO_JOB_ACTIVITES_FOUND}
                  </Typography>
                </Stack>
              )}
            </List>
            {filteredActivities?.length !== 0 && (
              <Button
                sx={{
                  mt: 1,
                  backgroundColor: hasSelectedActivities ? CLIENT_ACCENT_COLOR : "lightgrey",
                  color: "white",
                  borderRadius: "10px"
                }}
                fullWidth
                disabled={!hasSelectedActivities}
                onClick={handleAddJobs}>
                {BUTTON_NEXT}
              </Button>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default React.memo(ClientTimesheetActivitiesModal);
